import { render, staticRenderFns } from "./HondaRegistration.vue?vue&type=template&id=1a6b8122"
import script from "./HondaRegistration.vue?vue&type=script&lang=js"
export * from "./HondaRegistration.vue?vue&type=script&lang=js"
import style0 from "./HondaRegistration.vue?vue&type=style&index=0&id=1a6b8122&prod&lang=css"
import style1 from "./registration-styles.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports